import React from 'react';
import PropTypes from 'prop-types';
import InlineText from './InlineText';

function ErrorMessage({ children, ...rest }) {
  return (
    <InlineText {...rest} error>
      {children}
    </InlineText>
  );
}

ErrorMessage.propTypes = {
  children: PropTypes.any,
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/modules/common/ErrorMessage.js